import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/ProductCustomPrice";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Upsert = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export const Get = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:customerId/:productId`, options);

export const Delete = (options) =>
  GENERATE_URL(`${PREFIX_URL}/:customerId/:productId`, options);

export default {
  GetAll,
  Upsert,
  Get,
  Delete,
};
